// utils/offlineStorage/queueInstance.ts - utils/offlineStorage.ts split (sub-module queueInstance)


import { OperationQueue } from './queue.js';


export const operationQueue = new OperationQueue();
